import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SpecialText from "../Typography/SpecialText";
import { Rating } from "primereact/rating";
import Profile from "../../../assets/img/User.png";
import { Link, useLocation } from "react-router-dom";
import MainButton from "../MainButton/MainButton";
import Title from "../Title/Title";
import AuxiliaryText from "../Typography/AuxiliaryText";
import Pro from "../Tags/Pro";
import useAuth from "../../../Hooks/useAuth";
import { useGraphQL } from "../../../context/GraphQLProvider";
import { validateFile, getAcceptAttribute } from "../../../utils/contentSafety";
import Alerts from "../Alerts/Alerts";
import { fetchServiceCategories } from "../../../Redux/Slice/serviceCategoriesSlice";
import Heading from "../Typography/Heading";
import ProfileSpecialtyChips from "./ProfileSpecialtyChips";

const USER_TYPE = {
  CUSTOMER: "customer",
  SELLER: "seller",
};

const ProfileComponent = ({
  actions,
  reporting,
  link,
  heading,
  hoverView,
  profileCompleteion,
  dashboardActions,
  userData,
  minimal = false,
  hideDisplayName = false,
}) => {
  const dispatch = useDispatch();
  const graphqlService = useGraphQL();
  const stateUser = useSelector((state) => state.user);
  const { categories } = useSelector((state) => state.serviceCategories);
  const { auth } = useAuth();

  // Use userData from props if available, then state, then auth (sidebar often has auth from localStorage only)
  const userSource = userData || stateUser || auth;
  const {
    roleType,
    firstName,
    lastName,
    businessName,
    location: userLocation,
    profilePicture,
    startDate,
    serviceCategory,
    rating,
    views,
    shares
  } = userSource || {};


  const [serviceCategoryName, setServiceCategoryName] = useState("");

  // Fetch service categories if not already loaded
  useEffect(() => {
    const findServiceCategoryName = () => {
      if (categories && categories.length > 0 && serviceCategory?.id) {
        const categoryObj = categories.find(cat => cat.id === serviceCategory.id);
        setServiceCategoryName(categoryObj?.name || "");
      }
    };

    if (!categories || categories.length === 0) {
      dispatch(fetchServiceCategories(graphqlService));
    } else {
      findServiceCategoryName();
    }
  }, [dispatch, graphqlService, categories, serviceCategory]);

  const isCustomer = roleType === USER_TYPE.CUSTOMER;
  
  const displayName = isCustomer 
    ? `${firstName} ${lastName}`.trim() || "User Name"
    : businessName || "Business Name";

  const effectiveProfilePicture = profilePicture ?? auth?.user?.profilePicture ?? auth?.profilePicture;
  const [image, setImage] = useState(effectiveProfilePicture || Profile);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const location = useLocation();
  const completion = 50;

  useEffect(() => {
    if (effectiveProfilePicture) {
      setImage(effectiveProfilePicture);
    } else {
      setImage(Profile);
    }
  }, [effectiveProfilePicture]);

  // Pro tag: check auth.userPlan (top-level), auth.user.userPlan, or userData/stateUser
  const isProPlan =
    auth?.userPlan?.plan?.name?.toLowerCase() === "pro" ||
    auth?.user?.userPlan?.plan?.name?.toLowerCase() === "pro" ||
    (userData || stateUser)?.userPlan?.plan?.name?.toLowerCase() === "pro";

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const result = validateFile(file, "image");
    if (!result.valid) {
      Alerts.error(result.message);
      e.target.value = "";
      return;
    }
    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };
  
  console.log(selectedFile);
  console.log('123');

  if (minimal) {
    const isPro = userData?.userPlan?.plan?.name?.toLowerCase() === 'pro';
    return (
      <div className="flex flex-col items-start">
        <div className="relative z-20">
          <img
            className="avatar-display object-cover object-center cursor-pointer"
            src={userData?.profilePicture || image}
            alt={displayName}
          />
          {isPro && (
            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2">
              <Pro size="large" className="bg-primaryblue text-white" />
            </div>
          )}
        </div>
        {!hideDisplayName && (
          <div className="mt-5 ml-1 max-w-[30rem]">
            <Heading variant={"h1"} className={"text-offblack !component-heading !capitalize"}>
              {displayName}
            </Heading>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div>
        <div className="flex items-center justify-center md:justify-between">
          <div className="flex justify-center md:justify-start relative">
            <div className="relative">
              <div className="flex items-center justify-center md:justify-start md:gap-3">
                <div className="relative">
                  <img
                    className="avatar-standard object-cover object-center cursor-pointer bg-mediumgray"
                    src={selectedFile ? imagePreview : image}
                    alt={displayName}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = Profile;
                    }}
                  />
                  {location.pathname.includes("/business-dashboard") && isProPlan && (
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 -translate-y-0 z-10">
                      <Pro className="bg-primaryblue text-white" />
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* {auth?.user && (
              <div className="hidden group-hover:block absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="flex justify-center items-center bg-white rounded-full w-[30px] h-[30px] relative">
                  <div>
                    <input
                      type="file"
                      accept={getAcceptAttribute("image")}
                      onChange={handleFileInputChange}
                      id="profilePicture"
                      className="cursor-pointer hidden"
                    />
                    <label
                      role="button"
                      htmlFor="profilePicture"
                      className="flex justify-center bg-transparent"
                    >
                      <Title text={"Edit"} width={"50"}>
                        <i className="fi fi-rs-pen-circle text-xs text-mediumgray hover:text-primaryblue"></i>
                      </Title>
                    </label>
                  </div>
                </div>
              </div>
            )} */}
          </div>
          {/* progress performance */}
          {profileCompleteion && (
            <div className="hidden lg:block">
              <div className="flex items-center gap-2">
                <SpecialText variant={"Counter"}>
                  {completion}%
                </SpecialText>
                <div className="w-[90px] xl:w-[100px] h-2 bg-pastalblue rounded-full">
                  <div
                    className={`h-2 bg-freshgreen rounded-full w-[${completion}px]`}
                  ></div>
                </div>
              </div>
              <Link to={"/business-dashboard/settings/account"}>
                <AuxiliaryText
                  variant={"Placeholder"}
                  className={"text-primaryblue"}
                >
                  Complete your profile
                </AuxiliaryText>
              </Link>
            </div>
          )}
        </div>
        <div className="mt-5 text-center md:text-start">
          <div className="group/card lg:w-fit">
            {hoverView && (
              <div className="hidden lg:group-hover/card:block absolute z-20">
                <div className="bg-white -ml-28 sm:-ml-24 lg:ml-[90px] -mt-[210px] w-[350px] sm:w-[400px] h-[200px] rounded-xl p-5">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="relative">
                        <img
                          className="avatar-small object-cover object-center cursor-pointer"
                          src={image}
                          alt={displayName}
                        />
                        <div className="absolute -mt-3 left-[30%] mr-2">
                          <Pro className={"bg-primaryblue text-white"} />
                        </div>
                      </div>
                      <div className="ml-3">
                        <div>
                          <SpecialText variant={"ProfileName"}>
                            {displayName}
                          </SpecialText>
                        </div>
                        <div>
                          <SpecialText variant="ProfileMicro">
                            {userLocation}
                          </SpecialText>
                        </div>
                        {/* <div>
                          <SpecialText variant="ProfileMeta">
                            Gasfitting, Drainage, Roof Plumbing
                          </SpecialText>
                        </div> */}
                      </div>
                    </div>
                    <div>
                      <MainButton variant={"outlinesmall"}>
                        Follow
                      </MainButton>
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <div className="w-[100px] sm:w-[109px] h-[82px]">
                      <img
                        src={require("../../../assets/img/default-image.jpg")}
                        className="w-full h-full rounded-xl object-center"
                        alt="portfolio"
                      />
                    </div>
                    <div className="w-[100px] sm:w-[109px] h-[82px]">
                      <img
                        src={require("../../../assets/img/default-image.jpg")}
                        className="w-full h-full rounded-xl object-center"
                        alt="portfolio"
                      />
                    </div>
                    <div className="w-[100px] sm:w-[109px] h-[82px]">
                      <img
                        src={require("../../../assets/img/default-image.jpg")}
                        className="w-full h-full rounded-xl object-center"
                        alt="portfolio"
                      />
                    </div>
                  </div>
                </div>
                <div className="ml-[100px] w-0 h-0 border-l-[10px] border-l-transparent border-t-[15px] border-t-white border-r-[10px] border-r-transparent"></div>
              </div>
            )}
            <div className="md:w-fit">
              <Link to={link}>
                <SpecialText variant={"ProfileName"} className={"hover:text-primaryblue text-center xl:text-[1.0625rem]"}>
                  {displayName}
                </SpecialText>
              </Link>
            </div>
          </div>
          {!isCustomer && serviceCategoryName && (
            <div className="mt-3">
              <SpecialText variant="ProfileMeta">
                {serviceCategoryName}
              </SpecialText>
            </div>
          )}
          {location.pathname.includes("/business-dashboard") && (
            <div className="mt-2">
              <ProfileSpecialtyChips className="flex flex-wrap gap-y-2 gap-x-1" />
            </div>
          )}
          {/* {location.pathname !== '/poster-profile' && (
            <div className="mt-1">
              <SpecialText variant="ProfileMeta">
                Gasfitting Drainage Roof Plumbing
              </SpecialText>
            </div>
          )} */}
          {userLocation && (
            <div className="mt-2">
              <SpecialText variant="ProfileMicro">
                {userLocation}
              </SpecialText>
            </div>
          )}
          <div className="mt-1">
            <SpecialText variant={"Date"}>
              Member since {startDate ? new Date(startDate).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : 'N/A'}
            </SpecialText>
          </div>

          {location.pathname.includes("/business-dashboard") && (
            <div className="flex items-center justify-center md:justify-start mt-2">
              <div className="flex items-center">
                <Rating
                  value={rating ?? 4.3}
                  stars={1}
                  style={{ gap: 5 }}
                  cancel={false}
                  readOnly
                />
                <SpecialText variant="Counter" className="ml-1 text-offblack">
                  {(rating ?? 4.3).toFixed(1)}
                </SpecialText>
              </div>
            </div>
          )}

          {!actions && (
            <div className="flex items-center justify-center md:justify-start mt-3">
              <div className="pr-3">
                <Title text={"Report this business"} width={"120"} className={location.pathname.includes("SellerDashboard") ? "bg-pastalblue" : "bg-white"}>
                  <div>
                    <i className="fi fi-rs-flag-alt text-xs cursor-pointer hover:text-alertred" onClick={reporting}></i>
                  </div>
                </Title>
              </div>
              <div>
                <Title text={"Share this business"} width={"120"} className={location.pathname.includes("SellerDashboard") ? "bg-pastalblue" : "bg-white"}>
                  <div className="flex items-center px-3 border-l border-l-mediumgray">
                    <div>
                      <i className="fi fi-rs-share text-xs cursor-pointer mr-1"></i>
                    </div>
                    <SpecialText variant={"Counter"} className={"ml-1"}>
                      {shares || '0'}
                    </SpecialText>
                  </div>
                </Title>
              </div>
              <div>
                <Title text={"Business views"} width={"120"} className={location.pathname.includes("SellerDashboard") ? "bg-pastalblue" : "bg-white"}>
                  <div className="flex items-center border-l border-l-mediumgray border-r border-r-mediumgray px-3">
                    <div>
                      <i className="fi fi-rs-eye text-xs cursor-pointer mr-1"></i>
                    </div>
                    <SpecialText variant={"Counter"} className={"ml-1"}>
                      {views || '0'}
                    </SpecialText>
                  </div>
                </Title>
              </div>
              <div>
                <Title text={"Business rating"} width={"120"} className={location.pathname.includes("SellerDashboard") ? "bg-pastalblue" : "bg-white"}>
                  <div className="flex items-center pl-3">
                    <div>
                      <Rating value={rating || 0} stars={1} style={{ gap: 5 }} cancel={false} />
                    </div>
                    <SpecialText variant={"Counter"} className={"ml-1"}>
                      {rating?.toFixed(1) || '0.0'}
                    </SpecialText>
                  </div>
                </Title>
              </div>
            </div>
          )}
          {dashboardActions && (
            <div className="flex items-center mt-3">
              <div>
                <Title
                  text={"Share"}
                  width={"50"}
                  className={
                    location.pathname.includes("SellerDashboard")
                      ? "bg-pastalblue"
                      : "bg-white"
                  }
                >
                  <div className="flex items-center pr-3">
                    <div>
                      <i className="fi fi-rs-share text-xs cursor-pointer mr-1 "></i>
                    </div>
                    <SpecialText variant={"Counter"} className={"ml-1"}>
                      1k
                    </SpecialText>
                  </div>
                </Title>
              </div>
              <div>
                <Title
                  text={"Views"}
                  width={"50"}
                  className={
                    location.pathname.includes("SellerDashboard")
                      ? "bg-pastalblue"
                      : "bg-white"
                  }
                >
                  <div className="flex items-center border-l border-l-mediumgray border-r border-r-mediumgray px-3">
                    <div>
                      <i className="fi fi-rs-eye text-xs cursor-pointer mr-1"></i>
                    </div>
                    <SpecialText variant={"Counter"} className={"ml-1"}>
                      1k
                    </SpecialText>
                  </div>
                </Title>
              </div>
              <div>
                <Title
                  text={"Rating"}
                  width={"50"}
                  className={
                    location.pathname.includes("SellerDashboard")
                      ? "bg-pastalblue"
                      : "bg-white"
                  }
                >
                  <div className="flex items-center pl-3">
                    <div>
                      <Rating
                        value={3}
                        stars={1}
                        style={{ gap: 5 }}
                        cancel={false}
                        defaultValue={4}
                      />
                    </div>
                    <SpecialText variant={"Counter"} className={"ml-1"}>
                      4.9
                    </SpecialText>
                  </div>
                </Title>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileComponent;
